import { JsonObject, JsonProperty } from 'json2typescript';

import { ClientNotificationInterface } from '../../../core';

@JsonObject('ClientNotification')
export class ClientNotification implements ClientNotificationInterface {
    @JsonProperty('Type', String, true)
    private _type: string = undefined;

    @JsonProperty('Reason', String, true)
    private _reason: string = undefined;

    get type(): string {
        return this._type;
    }

    get reason(): string {
        return this._reason;
    }
}
